<script lang="ts">
  import StorefrontContainer from "@shared/svelte/Components/Storefront/StorefrontContainer.svelte";
  import { default as CraftNavigation } from "@modern/components/retailer/Navigation/ProductLinesNavigation.svelte";
  import Spinner from "@shared/svelte/Components/Spinner.svelte";
  import DemoSignupModal from "@shared/svelte/Components/Layout/DemoHeader/DemoSignupModal.svelte";

  import type { Storefront } from "@shared/types/Storefront";
  import { HttpPromise, HttpPromiseWithEntireResponse } from "@shared/svelte/Modules/ApiService";
  import { params, beforeUrlChange } from "@roxi/routify";
  import { onMount } from "svelte";

  let catalogPage: number = 1;
  let isLoading: boolean = true;
  let distributorId: number = $params.distributorId;
  let storefront: Storefront;

  const pullCatalog = async params => {
    const options = {
      method: "GET",
      url: "/api/distributor/product_lines/demo_search",
      data: {
        limit: storefront.catalog_items_per_page,
        distributor_id: storefront.distributor_id,
        offset: storefront.catalog_items_per_page * (catalogPage > 0 ? catalogPage - 1 : 0),
        catalog_sort: storefront.catalog_sort_by,
        storefront: true,
        ...params,
      },
    };
    const res = await HttpPromiseWithEntireResponse(options);

    const catalogPagination = {
      perPage: storefront.catalog_items_per_page,
      page: catalogPage,
      totalEntries: parseInt(res.headers.get("X-Pagination-Entries")),
      goToPage: n => {
        catalogPage = n;
        pullCatalog(params);
      },
    };
    const catalog = await res.json();

    storefront = {
      ...storefront,
      catalog,
      catalogPagination,
    };
    return res;
  };

  const pullAvailableFilters = params => {
    return HttpPromise({
      method: "GET",
      url: "/api/distributor/product_lines/available_filters",
      data: {
        ...params,
        specified_distributor_id: distributorId,
      },
    });
  };

  const load = async () => {
    try {
      storefront = await HttpPromise({
        method: "GET",
        url: "/api/retailer/storefronts/demo_storefront/",
        data: { distributor_id: $params.distributorId },
      });
      pullCatalog({});
    } catch (error) {
      window.location.href = "/404";
    }
  };

  onMount(async () => {
    await load();
    isLoading = false;
  });

  $beforeUrlChange(() => {
    openSignupModal;
    return false;
  });

  const openSignupModal = () => {
    window["svelteModal"](DemoSignupModal, {});
  };

  const callbacks = {
    pullCatalog,
    pullAvailableFilters,
  };
</script>

{#if isLoading}
  <Spinner />
{:else}
  <div>
    <CraftNavigation />
  </div>
  <StorefrontContainer {storefront} {callbacks} />
{/if}
